import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar.json';
import de from './locales/de.json';

let savedLanguage: string | null = null;
try {
  savedLanguage = localStorage.getItem('waschpilot-language');
} catch {
  /* Preferences can still live in memory. */
}
const initialLanguage = savedLanguage === 'ar' ? 'ar' : 'de';

void i18n.use(initReactI18next).init({
  resources: { de: { translation: de }, ar: { translation: ar } },
  lng: initialLanguage,
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function applyDocumentLanguage(language: string): void {
  const locale = language === 'ar' ? 'ar' : 'de';
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
  try {
    localStorage.setItem('waschpilot-language', locale);
  } catch {
    /* Document language still changes when storage is unavailable. */
  }
}

applyDocumentLanguage(initialLanguage);

export default i18n;
